import { Routes } from '@angular/router';
import { OrgChooserComponent } from '../upgrade/accounts.directive';
import { initGuard } from '@fry/upgrade/init.guard';

export const accountsRoutes: Routes = [
  {
    path: 'org-chooser',
    component: OrgChooserComponent,
    data: {
      state: 'accounts.org-chooser'
    },
    canActivate: [initGuard]
  }
];
